// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ApdWo{height:100%;display:flex;flex-direction:column}.eiQ9h{position:sticky;top:0;z-index:1;padding:24px 24px 16px}.TpPW3{flex:1;overflow-y:auto;padding:0 24px}.bbVGW{flex:1}.zjxZG{position:sticky;bottom:0;z-index:1;padding:16px 24px 24px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `ApdWo`,
	"header": `eiQ9h`,
	"content": `TpPW3`,
	"progressBarContainer": `bbVGW`,
	"footer": `zjxZG`
};
export default ___CSS_LOADER_EXPORT___;
